import { Button, DropdownMenu, SearchInput, Toggle, Typography } from "@/components/atoms";
import { FILTERS } from "./fixtures";
import { UseJobHistorySearchFilters } from "./useJobHistorySearchFilters";

export const JobHistorySearchFilters = ({ searchFiltersContext }: { searchFiltersContext: UseJobHistorySearchFilters }) => {
  const { mode, setMode, search, setSearch, filters, setFilters } = searchFiltersContext;

  return (
    <section>
      {mode === "default" && (
        <div className="flex items-center gap-3">
          <Button size="sm" startIcon="SearchNormal1" variant="secondary" onClick={() => setMode("search")}>
            Search
          </Button>
          <DropdownMenu
            button={
              <Button size="sm" startIcon="Eye" variant="secondary">
                Filter Events
              </Button>
            }
            position="bottom-start"
          >
            {Object.entries(FILTERS).map(([key, value]) => (
              <DropdownMenu.Item
                key={key}
                className="hover:text-inherit relative flex w-[210px] cursor-default items-center justify-between hover:bg-transparent"
                disabled
              >
                <Typography variant="paragraph">{value}</Typography>
                <Toggle
                  size="xs"
                  checked={filters.includes(key)}
                  onChange={(checked) => setFilters(checked ? [...filters, key] : filters.filter((i) => i !== key))}
                />
              </DropdownMenu.Item>
            ))}
          </DropdownMenu>
        </div>
      )}
      {mode === "search" && (
        <SearchInput
          size="md"
          search={search}
          onSearch={(e) => setSearch(e ?? "")}
          onClear={() => {
            setSearch("");
            setMode("default");
          }}
          debounceTime={300}
          className="w-full"
          autoFocus
        />
      )}
      {/* {mode === "search" ? (
        <Card className="grid space-y-4">
          <Typography variant="action">Search Modifier</Typography>
          <SearchInput size="md" value={search} onSearch={(e) => setSearch(e ?? "")} debounceTime={0} />
        </Card>
      ) : mode === "filter" ? (
        <Card className="grid space-y-4">
          <Typography variant="action">Filter Events by</Typography>
          <CheckboxInput
            label="Select all"
            checked={filters.length === Object.keys(FILTERS).length}
            onChange={(e) => setFilters(e.target.checked ? Object.keys(FILTERS) : [])}
          />
          <div className="flex items-center gap-2.5 max-sm:grid max-sm:grid-cols-3">
            {Object.entries(FILTERS).map(([key, value]) => (
              <CheckboxInput
                key={key}
                variant="check"
                label={value}
                checked={filters.includes(key)}
                onChange={(e) => {
                  setFilters(e.target.checked ? [...filters, key] : filters.filter((i) => i !== key));
                }}
              />
            ))}
          </div>
        </Card>
      ) : null} */}
    </section>
  );
};
